export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Алушы: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пайдаланушы табылмады"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Байланыстар"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Толығырақ"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пайдаланушыларды таңдау"])}
}